module.exports = __webpack_public_path__ + "static/media/bell.0f3dedb4.svg";